module.exports = "<div class=\"form-cell form-setting-textarea\"> <div class=wrap> <div class=content> {{#if unvisible}} <p class=info>权限受限</p> {{else if be_control_condition}} <p class=info>被修改条件限制</p> {{else}} <textarea disabled=disabled class=ui-width></textarea> <input type=button value=设置 class=button> {{#if required}} <span id=requiredLogo class=\"{{requiredClass}} form-print-icon\" style=position:relative;top:5px;vertical-align:top;float:none></span> {{/if}} {{/if}} </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/setting-textarea-control/setting-textarea.html
// module id = 4709
// module chunks = 50